import { useEffect } from 'react';

import { sendGAEvent } from '@utils/google-analytics';

export const useGAAutoBinding = (deps: any[]) => {
  useEffect(() => {
    const classPrefix = 'GA-';
    const elements = Array.from<HTMLElement>(
      document.querySelectorAll(`[class*=${classPrefix}]`),
    );

    const removeListenersArray: (() => void)[] = [];

    elements.forEach((element) => {
      element.classList.forEach((className) => {
        if (/^GA-/.test(className)) {
          const [_, category, eventLabel] = className.split('-');

          const eventHandler = () => {
            sendGAEvent(category, 'click', eventLabel);
          };

          element.addEventListener('click', eventHandler);
          removeListenersArray.push(() =>
            element.removeEventListener('click', eventHandler),
          );
        }
      });
    });

    return () => {
      removeListenersArray.forEach((removeFunction) => removeFunction());
    };
  }, [deps]);
};
